<template>
  <div class="instFotoWrap" v-if="!hideThis" v-bind:class="{'isLoading':isLoading}">
    <div class="instFotoPreView">
      <div class="instPrviewBox">
        <img src="@/assets/images/passport1.png" alt="" v-if="imageData.length === 0 && fieldName === 'passport1'">
        <img src="@/assets/images/passport2.png" alt="" v-if="imageData.length === 0  && fieldName === 'passport2'">
        <img src="@/assets/images/self.png" alt="" v-if="imageData.length === 0  && fieldName === 'selfImage'">
        <img src="@/assets/images/bank.png" alt="" v-if="imageData.length === 0 && fieldName ===  'BankAccount'">
      </div>
      <div class="instFotoPreviewContent"
           v-bind:style="{'background-image':'url('+ imageData + ')'}"
      >

        <div class="instFotoPreviewLayerDone" v-show="imgDone">
          <img src="@/assets/vector/allDone.svg" svg-inline>
        </div>
        <div class="instFotoPreviewLayerFail" v-show="fieldStatus.code !== 0 && fieldStatus.ShowError">
          <img src="@/assets/vector/fail.svg" svg-inline>
        </div>
      </div>
    </div>
    <div class="instFotoAction">
      <p class="instFotoTitle">{{item.label}}</p>
      <p class="instFotoInfo">{{item.info}}</p>
      <p class="instErrMsg" v-if="fieldStatus.ShowError" v-html="fieldStatus.msg"></p>
      <div class="instActionInputWrap">
        <div>
          <input type="file" accept="image/*" v-on:change="previewImage">
          <p>Загрузить фото из галереи</p>
        </div>
        <div>
          <input type="file" accept="image/*" :capture="item.capture" v-on:change="previewImage">
          <p>Сделать фото</p>
        </div>
      </div>
    </div>
    <loader v-if="isLoading"></loader>
  </div>
</template>

<script>
import DataForInput from '@/store/Form/longFormOptions';
import {mapState} from "vuex";
export default {
  name: "instFotoAdd",
  props: {
    fieldName: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      item: DataForInput[this.fieldName],
      imageData: '',
      isLoading:false,
      hideThis:false
    }
  },
  methods:{
    previewImage: function (event) {

      this.imageData = '';
      const allowedExtensions = ['jpg', 'jpeg', 'png'];

      // Reference to the DOM input element
      let input = event.target;
      const fileExtension = input.files[0].name.split('.').pop().toLowerCase();
      // let self = this;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0] && allowedExtensions.includes(fileExtension)) {
        // create a new FileReader to read this image and convert to base64 format
        let reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = async (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          if (e.target.result.startsWith('data:image/jpeg') ||
              e.target.result.startsWith('data:image/jpg') ||
              e.target.result.startsWith('data:image/png')) {
            this.imageData = e.target.result;
            this.isLoading = true;
            const result = await this.$store.dispatch('tryUploadFile', {
              fileName: this.fieldName,
              fileValue: e.target.result
            });
            if (result.execution) {
              this.$store.dispatch('saveSendData', {
                target: this.fieldName,
                value: result.fileId
              });
            } else {
              this.imageData = '';
              await this.$store.commit('saveWorkData', {
                target:this.fieldName,
                status:{
                  code:1,
                  msg:result.msg,
                  disable:false
                }
              });
              await this.$store.commit('saveErrorShow', {
                target:this.fieldName,
                value:true
              });
            }
            this.isLoading = false

          } else {
            this.$palantir.trackAction(192, JSON.stringify({
              if:'e.target.result.startsWith(data:image *** '
            }));
            alert('Ошибка! Нужен JPG или PNG. Проверьте формат и загрузите снова.')
          }
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      } else {
        this.$palantir.trackAction(192, JSON.stringify({
          if:'input.files && input.files[0] && allowedExtensions.includes(fileExtension)',
          value:fileExtension
        }));
        alert('Ошибка! Нужен JPG или PNG. Проверьте формат и загрузите снова.')
      }
    },
    hideIfIsset(){
      if (this.demandState.allPhotosStatusList[this.fieldName] > 0) {
        this.hideThis = true;
        this.$store.dispatch('saveSendData', {
          target: this.fieldName,
          value: this.demandState.allPhotosStatusList[this.fieldName]
        });
      }
    }
  },
  computed:{
    ...mapState({
      valueVuex: state => state.Form.sendData,
      statusVuex: state => state.Form.workData,
      demandState: state => state.instForm.demandState,
    }),
    imgDone(){
      return this.valueVuex[this.fieldName] > 0;
    },
    fieldStatus() {
      return this.statusVuex[this.fieldName];
    }
  },
  components:{
    loader: () => import('@/views/pdlloan/uiLoader'),
  },
  mounted() {
    console.log('fotoComponent mounted');
    this.hideIfIsset();
  }
}
</script>

<style scoped>
.instFotoWrap{
  position: relative;
  background: var(--color-gray-type2);padding: var(--font-size-20) var(--font-size-14);
  display: flex;align-items: flex-start;justify-content: space-between;
  margin: 0 auto var(--font-size-16);border-radius: var(--font-size-04);
}
.instFotoWrap.isLoading{pointer-events: none;}
.instFotoWrap.isLoading .instFotoPreView, .instFotoWrap.isLoading .instFotoAction {opacity: 0.4}
.instFotoPreView{width: var(--font-size-74);height: var(--font-size-100);background: white;position: relative;}
.instFotoPreviewContent{position: absolute;top:var(--font-size-02);left:var(--font-size-02);
  width: calc(100% - var(--font-size-04));height: calc(100% - var(--font-size-04));background-size: contain;
  background-position: center;background-repeat: no-repeat}
.instFotoPreviewContent div{position: absolute;top:0;left:0;width: 100%;height: 100%;display: flex;align-items: center;justify-content: center}
.instFotoPreviewContent div svg{width: var(--font-size-22);height:var(--font-size-22) }
.instFotoPreviewLayerDone{background: var(--color-green);opacity: 0.5}
.instFotoPreviewLayerFail{background: var(--color-red-type1);opacity: 0.5}
.instFotoAction{width: calc(100% - var(--font-size-74) - var(--font-size-14) )}
.instFotoTitle{font-weight: 500;font-size: var(--font-size-16);margin-bottom: var(--font-size-13)}
.instFotoInfo{font-size: var(--font-size-14);color:var(--color-gray-type3);margin-bottom: var(--font-size-13)}
.instActionInputWrap {display: flex;align-items: center;justify-content: space-between}
.instActionInputWrap div {position: relative;padding: var(--font-size-04);width: 50%;text-align: center}
.instActionInputWrap div input{position: absolute;top:0;left:0;width: 100%;height: 100%;opacity: 0}
.instActionInputWrap div p{color:var(--color-dark-green);font-size: var(--font-size-16);pointer-events: none}
.instPrviewBox{display: flex;align-items: center;justify-content: center;height: 100%}
.instPrviewBox img{max-width: 100%}
</style>